export default {
    root: {
        color: 'fff'
    }
};
